import React, { useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Text,
  Button,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {PackageOpen, Coins, Ruler } from "lucide-react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";
import PackageManagement from "../PackageManagement";
import ManageClaimsTab from "../ClaimsManagement";
import SizeEstimates from "../SizeEstimatesManagement";

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

const PackageTabs = () => {
  return (
    <Box w="100%" p={4} mt={"70px"} ml={"9px"}>

      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={PackageOpen} label="Packages" />
          <CustomTab icon={Coins} label="Claims" />
          <CustomTab icon={Ruler} label="Package Sizes Management" />
        </TabList>

        <TabPanels>
          <TabPanel>
            <PackageManagement />
          </TabPanel>
          <TabPanel>
            <ManageClaimsTab />
          </TabPanel>

          <TabPanel>
            <SizeEstimates />
          </TabPanel>

        </TabPanels>
      </Tabs>
    </Box>
  );
};


export default PackageTabs;
